import Matter from "matter-js";
import * as C from "../../config/constants.js";
import {
  enforceContainmentIfDue,
  enforceMouthEscapeContainment,
  resolvePhysicsSubsteps,
} from "./containment.js";
import { updateMergeMotions } from "./merge-motion.js";
import { updateShrinkMotions } from "./shrink-motion.js";

export function updateSystem(system, deltaMs) {
  if (!system.engine) return;
  if (typeof system.syncEngineGravity === "function") system.syncEngineGravity();
  var rc = system.runConfig || {};
  var fallbackStepMs = 1000 / 60;
  var maxFrameMs = (rc.MAX_FRAME_DELTA_MS != null)
    ? Number(rc.MAX_FRAME_DELTA_MS)
    : (C.MAX_FRAME_DELTA_MS != null ? Number(C.MAX_FRAME_DELTA_MS) : 100);
  var fixedStepMs = (rc.FLASK_PHYSICS_STEP_MS != null)
    ? Number(rc.FLASK_PHYSICS_STEP_MS)
    : (C.FLASK_PHYSICS_STEP_MS != null
      ? Number(C.FLASK_PHYSICS_STEP_MS)
      : fallbackStepMs);
  var maxSubsteps = (rc.FLASK_PHYSICS_MAX_SUBSTEPS != null)
    ? Number(rc.FLASK_PHYSICS_MAX_SUBSTEPS)
    : (C.FLASK_PHYSICS_MAX_SUBSTEPS != null
      ? Number(C.FLASK_PHYSICS_MAX_SUBSTEPS)
      : 6);
  var safeDelta = Number(deltaMs);
  if (!isFinite(safeDelta) || safeDelta <= 0) return;
  var clampedDelta = Math.min(maxFrameMs, safeDelta);
  var substeps = resolvePhysicsSubsteps(system, clampedDelta, fixedStepMs, maxSubsteps);
  var stepMs = clampedDelta / substeps;
  for (var i = 0; i < substeps; i++) {
    enforceMouthEscapeContainment(system, "pre");
    Matter.Engine.update(system.engine, stepMs);
    enforceMouthEscapeContainment(system, "post");
  }
  enforceContainmentIfDue(system);
  updateMergeMotions(system);
  updateShrinkMotions(system);
}